import { HttpClient, HttpResponse } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Consortium } from '../../../features/feature-project-details/models/consortium.interface'
import { FinalProposal } from '../../../features/feature-project-details/models/final-proposal.interface'
import { ProjectDetailResponse } from '../../../features/feature-project-details/models/project-detail.interface'
import { ConfigService } from '../../services/config.service'
import { LogService } from '../../services/log.service'

@Injectable({ providedIn: 'root' })
export class FeaturePDService {
   private _cn = this.constructor.name
   private _httpClient = inject(HttpClient)
   private _logService = inject(LogService)
   private _configService = inject(ConfigService)

   getProjectById(id: string, status: string): Observable<ProjectDetailResponse> {
      this._logService.info(this._cn, this.getProjectById.name, this._logService.START)
      this._logService.info(this._cn, this.getProjectById.name, 'project id: ', id)
      return this._httpClient.get<ProjectDetailResponse>(`${this._configService.apiUrl}/projects/${id}?status=${status}`)
   }

   retriveProjectConsortium(id: string): Observable<Consortium> {
      this._logService.info(this._cn, this.retriveProjectConsortium.name, this._logService.START)
      this._logService.info(this._cn, this.retriveProjectConsortium.name, 'project id: ', id)
      return this._httpClient.get<Consortium>(`${this._configService.apiUrl}/projects/${id}/consortium`)
   }

   retriveProjectProposals(id: string): Observable<FinalProposal[]> {
      this._logService.info(this._cn, this.retriveProjectProposals.name, this._logService.START)
      this._logService.info(this._cn, this.retriveProjectProposals.name, 'project id: ', id)
      return this._httpClient.get<FinalProposal[]>(`${this._configService.apiUrl}/projects/${id}/final-proposal/documents`)
   }

   downloadFinalProposal(projectId: string, fileId: string): Observable<HttpResponse<Blob>> {
      this._logService.info(this._cn, this.downloadFinalProposal.name, this._logService.START)
      this._logService.debug(this._cn, this.downloadFinalProposal.name, 'project id:', projectId)
      this._logService.debug(this._cn, this.downloadFinalProposal.name, 'file id:', fileId)
      return this._httpClient.get<Blob>(`${this._configService.apiUrl}/projects/${projectId}/final-proposal/documents/${fileId}`, {
         headers: { Accept: '*/*' },
         responseType: 'blob' as 'json',
         observe: 'response',
      })
   }
}
